import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Text, SvgIcon, ButtonFilled } from 'Components/Base';
import Review from 'Containers/Review';
import { myProfile } from 'Redux/user-profile/selectors';
import { useGetFeedback } from 'Util/FeedBackService';
import { useClassroomInterruption } from 'Util/Hooks';
import { sendDataToGTM, GTM_EVENT_NAME, GTM_DATA_LAYER_PROPERTY } from 'Util/Analytics';

const CourseReviewButton = ({ sidebarContentPadding, isMinimize, isMobile, userId }) => {
  const { t } = useTranslation('classroom');

  const {
    isInterrupting,
    activateInterruption,
    deactivateInterruption,
    courseData: { courseCode, progressPercent, courseTitle },
  } = useClassroomInterruption();

  const { data: reviewData } = useGetFeedback({
    templateId: 'SKOOLDIO_FEEDBACK',
    contentId: courseCode,
    userId,
  });

  const reviews = useMemo(() => {
    return reviewData?.getFeedback ?? [];
  }, [reviewData]);

  const isReviewed = useMemo(() => {
    return reviews.length !== 0;
  }, [reviews]);

  const lastReviewRevision = useMemo(() => {
    if (isReviewed) {
      return reviews[0].data;
    }
    return {};
  }, [isReviewed, reviewData]);

  if (progressPercent < 80) return null;

  const handleReviewCourseButtonClick = () => {
    if (typeof activateInterruption === 'function') {
      activateInterruption();

      // logging GTM event
      sendDataToGTM({
        event: GTM_EVENT_NAME.REVIEW_BUTTON_CLICK,
        [GTM_DATA_LAYER_PROPERTY.PRODUCT_TITLE]: courseTitle,
      });
    }
  };

  return (
    <>
      <ButtonFilled
        px={sidebarContentPadding}
        py={4}
        onClick={handleReviewCourseButtonClick}
        color={'white'}
        border={0}
        width="100%"
      >
        <Flex alignItems="center">
          <Text lineHeight={0} mr={5} color="primary">
            <SvgIcon size={24} icon={SvgIcon.ICON_LIST.RATING_STAR_OUTLINED} />
          </Text>
          {(!isMinimize || isMobile) && (
            <Text fontWeight="medium" fontFamily="content" color={'text'}>
              {t('REVIEW_COURSE')}
            </Text>
          )}
        </Flex>
      </ButtonFilled>
      {isInterrupting && (
        <Review
          isShow={isInterrupting}
          onCloseReview={deactivateInterruption}
          progressPercent={progressPercent}
          review={lastReviewRevision}
          revision={reviews.length + 1}
        />
      )}
    </>
  );
};

export default connect((state) => {
  const user = myProfile(state);
  return {
    userId: user.id,
  };
}, {})(CourseReviewButton);
